import appConfig from 'src/utils/appConfig';

/* globals __webpack_public_path__ */

export default () => {
  // disable eslint camelcase check for global wepback variable __weback_public_path__
  __webpack_public_path__ = appConfig.getMyConfig().assetUrl; // eslint-disable-line camelcase
};
